<template>
  <div :id="mainId" class="al-menu-simple" test-id="al-menu-simple">
    <div v-if="title" class="al-menu-simple-header">{{ title }}</div>
    <div class="al-menu-simple-body">
      <slot>
        <ul>
          <template v-for="(item, index) in items">
            <li :key="index" :class="[{ disabled: item.disabled }]">
              <a href="javascript:;" @click="click(item)">{{ item.name }}</a>
            </li>
          </template>
        </ul>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlMenuSimple',
  // -------------------------------------------------
  // + Life Cicle
  // -------------------------------------------------
  components: {},
  props: {
    /**
     * Element Identify
     */
    title: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    mainId() {
      // eslint-disable-next-line no-underscore-dangle
      const id = this.id ? this.id : this._uid;
      return `contextual-menu-${id}`;
    }
  },
  methods: {
    click(item) {
      if (item.to) {
        this.goTo(item.to);
        return;
      }
      this.emit(item.emit);
    },
    goTo(route) {
      this.$router.push(route);
    },
    emit(emit) {
      this.$emit('action', emit);
    }
  }
};
</script>
<style lang="scss">
/**
* Variables
*/
$font-size-header: 12.8px;
$font-color-header: #9b9f9f;
$p-header: 0 12px 4px;

$font-size-item-menu: 16px;
$font-color-item-menu: #68706f;
$font-color-item-menu-hover: #04100f;
$bg-color-item-menu-hover: #dff7ef;

$font-color-item-menu-disabled: #9b9f9f;
$bg-color-item-menu-disabled: #f5f8f7;

$p-item-menu: 6px 12px 6px;

.al-menu-simple-header {
  color: $font-color-header;
  font-size: $font-size-header;
  padding: $p-header;
  text-transform: uppercase;
}

.al-menu-simple-body {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      font-size: $font-size-item-menu;

      a {
        color: $font-color-item-menu;
        display: block;
        font-family: 'realistic', Helvetica;
        line-height: 24px;
        padding: $p-item-menu;

        &:hover {
          background-color: $bg-color-item-menu-hover;
          color: $font-color-item-menu-hover;
          outline: none;
          text-decoration: none;
        }
      }

      &.disabled {
        a {
          background-color: $bg-color-item-menu-disabled;
          color: $font-color-item-menu;
          cursor: not-allowed;

          &:hover {
            background-color: $bg-color-item-menu-disabled;
            color: $font-color-item-menu;
          }
        }
      }
    }
  }
}
</style>
